import { useCallback } from "react";
import { useGroupFieldsPer } from "./useGroupFieldsPer";

export const useCommonFieldsWith = () => {
  const { getFieldsPerFarmer, getFieldsPerAgronomist } = useGroupFieldsPer();

  const getCommonFieldsWithFarmer = useCallback(
    (farmerEmail) => {
      const commonFieldsWithFarmer = getFieldsPerFarmer();
      return commonFieldsWithFarmer?.[farmerEmail]?.fields;
    },
    [getFieldsPerFarmer]
  );

  const getCommonFieldsWithAgronomist = useCallback(
    (agronomistEmail) => {
      const commonFieldsWithAgronomist = getFieldsPerAgronomist();
      return commonFieldsWithAgronomist?.[agronomistEmail]?.fields;
    },
    [getFieldsPerAgronomist]
  );

  return { getCommonFieldsWithFarmer, getCommonFieldsWithAgronomist };
};
